module.exports = __webpack_public_path__ + "assets/img/order_success.91a4d1d4.png";